import { c as _c } from "react/compiler-runtime";
import { useThemeStore } from "@/store/theme-store";
import { Button } from "@headlessui/react";
import { TextMono } from "@/components/ui/text";
import { ChevronUpDownIcon } from "@heroicons/react/16/solid";
export const ColorThemeToggle = () => {
  const $ = _c(9);
  const theme = useThemeStore(_temp);
  const setTheme = useThemeStore(_temp2);
  let t0;
  if ($[0] !== setTheme || $[1] !== theme) {
    t0 = () => {
      setTheme(theme === "dark" ? "light" : "dark");
    };
    $[0] = setTheme;
    $[1] = theme;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleThemeChange = t0;
  let t1;
  if ($[3] !== theme) {
    t1 = <TextMono>{theme} theme</TextMono>;
    $[3] = theme;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronUpDownIcon className="text-border dark:text-muted-foreground/25 group-hover/theme-toggle:text-muted-foreground/75 group-data-[open]/theme-toggle:text-muted-foreground/75 size-3.5" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== handleThemeChange || $[7] !== t1) {
    t3 = <Button onClick={handleThemeChange} className="group/theme-toggle data-hover:bg-border/35 data-focus:bg-border/50 flex items-center justify-between gap-1 border-l p-3 data-focus:-outline-offset-2 data-focus:outline-blue-500 sm:min-w-44 sm:ps-6 sm:pe-4">{t1}{t2}</Button>;
    $[6] = handleThemeChange;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
function _temp(state) {
  return state.theme;
}
function _temp2(state_0) {
  return state_0.setTheme;
}